export type UserSpotlightCtaPersona = 'manager' | 'recipient' | 'viewer';

export const userSpotlightCtaPersonas: UserSpotlightCtaPersona[] = ['manager', 'recipient', 'viewer'];

export type UserSpotlightCtaCopyNode = { kind: 't'; i18nKey: string } | { kind: 'trans'; i18nKey: string; values: Record<string, unknown> };

export function isUserSpotlightCtaPersona(value: string | null): value is UserSpotlightCtaPersona {
	return Boolean(value) && userSpotlightCtaPersonas.includes(value as UserSpotlightCtaPersona);
}

export function deriveUserSpotlightCtaPersona({
	isViewingOwnSpotlight,
	canEditSpotlight,
	overridePersona,
}: {
	isViewingOwnSpotlight: boolean;
	canEditSpotlight: boolean;
	overridePersona?: UserSpotlightCtaPersona;
}): UserSpotlightCtaPersona {
	if (overridePersona) return overridePersona;
	if (isViewingOwnSpotlight) return 'recipient';
	if (canEditSpotlight) return 'manager';
	return 'viewer';
}

export function getUserSpotlightCtaCopyNodes({ persona, userDisplayFirstName }: { persona: UserSpotlightCtaPersona; userDisplayFirstName?: string }): {
	headingNode: UserSpotlightCtaCopyNode;
	bodyNode: UserSpotlightCtaCopyNode;
	footerNode: UserSpotlightCtaCopyNode;
} {
	const hasName = Boolean(userDisplayFirstName);

	const headingNode: UserSpotlightCtaCopyNode =
		persona === 'manager'
			? { kind: 't', i18nKey: 'callToAction.persona.manager.heading' }
			: persona === 'recipient'
				? !hasName
					? { kind: 't', i18nKey: 'callToAction.persona.recipient.headingWithoutName' }
					: { kind: 'trans', i18nKey: 'callToAction.persona.recipient.headingWithName', values: { name: userDisplayFirstName } }
				: !hasName
					? { kind: 't', i18nKey: 'callToAction.persona.viewer.headingWithoutName' }
					: { kind: 'trans', i18nKey: 'callToAction.persona.viewer.headingWithName', values: { name: userDisplayFirstName } };

	const bodyNode: UserSpotlightCtaCopyNode =
		persona === 'manager'
			? !hasName
				? { kind: 't', i18nKey: 'callToAction.persona.manager.bodyWithoutName' }
				: { kind: 'trans', i18nKey: 'callToAction.persona.manager.bodyWithName', values: { name: userDisplayFirstName } }
			: persona === 'recipient'
				? { kind: 't', i18nKey: 'callToAction.persona.recipient.body' }
				: !hasName
					? { kind: 't', i18nKey: 'callToAction.persona.viewer.bodyWithoutName' }
					: { kind: 'trans', i18nKey: 'callToAction.persona.viewer.bodyWithName', values: { name: userDisplayFirstName } };

	const footerNode: UserSpotlightCtaCopyNode =
		persona === 'manager'
			? !hasName
				? { kind: 't', i18nKey: 'callToAction.persona.manager.footerWithoutName' }
				: { kind: 'trans', i18nKey: 'callToAction.persona.manager.footerWithName', values: { name: userDisplayFirstName } }
			: persona === 'recipient'
				? { kind: 't', i18nKey: 'callToAction.persona.recipient.footer' }
				: !hasName
					? { kind: 't', i18nKey: 'callToAction.persona.viewer.footerWithoutName' }
					: { kind: 'trans', i18nKey: 'callToAction.persona.viewer.footerWithName', values: { name: userDisplayFirstName } };

	return { headingNode, bodyNode, footerNode };
}
